import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { useGetWorkstations } from '@/hooks/useGetWorkstations';
import * as S from '@/components/Settings/DataExtraction/styles';

const { useWatch } = Form;

export function WorkstationFormItem(): JSX.Element {
	const organization_id: string = useWatch(['general_information', 'organization_id']);
	const company_id: string = useWatch(['general_information', 'company_id']);
	const sector_id: string = useWatch(['general_information', 'sector_id']);
	const line_id: string = useWatch(['general_information', 'line_id']);

	const workstations = useGetWorkstations({
		organization_id,
		company_id,
		sector_id,
		line_id
	});

	const isDisabled: boolean = !organization_id || !company_id || !sector_id || !line_id;

	return (
		<S.CustomFormItem
			name={['general_information', 'workstation_id']}
			label={I18n.get('Workstation')}
			labelCol={{ span: 24 }}
		>
			<SelectOptions
				allowClear
				disabled={isDisabled}
				options={workstations.data}
				loading={workstations.isFetching}
				placeholder={I18n.get('Workstation')}
			/>
		</S.CustomFormItem>
	);
}
